import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/common/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-c2e63996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-auth p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = { class: "header mb-1" }
const _hoisted_4 = { class: "sub-header" }
const _hoisted_5 = { class: "flex items-center content-login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.intl("user-login-page.header")), 1),
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.intl("user-login-page.sub-header")), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ion_button, {
                class: "w-full",
                type: "button",
                onClick: _ctx.onLoginClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.intl("user-login-page.title.login")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}